import { useSearchParams } from 'react-router-dom'

export const DEFAULT_URL_PAGE_SIZE = 10

const parsePositiveInteger = (value: string | null, fallback: number) => {
  const parsed = Number(value)
  return Number.isInteger(parsed) && parsed >= 1 ? parsed : fallback
}

export const useUrlPagination = (pageKey: string, pageSizeKey: string) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const page = parsePositiveInteger(searchParams.get(pageKey), 1)
  const pageSize = parsePositiveInteger(searchParams.get(pageSizeKey), DEFAULT_URL_PAGE_SIZE)

  const setPage = (value: number) => {
    setSearchParams(
      (params) => {
        params.set(pageKey, `${value}`)
        return params
      },
      { replace: true },
    )
  }

  const setPageSize = (value: number | undefined) => {
    if (!value) {
      return
    }
    setSearchParams(
      (params) => {
        params.set(pageSizeKey, `${value}`)
        params.set(pageKey, '1')
        return params
      },
      { replace: true },
    )
  }

  return { page, pageSize, pageRequest: { page: page - 1, size: pageSize }, setPage, setPageSize }
}

export type UrlPagination = ReturnType<typeof useUrlPagination>
